/**
 * Derives active product booleans from general_info streams (same logic as EditCamera generateActiveProducts).
 * Used for autopatrol Site About camera rows only.
 */

/** Maps bulk / UI display names to API `label_name` keys (shared with metric simplified). */
export const DISPLAY_NAME_TO_LABEL_NAMES: Record<string, string[]> = {
  Intruder: ["intruder"],
  Vehicle: ["vehicle"],
  Bike: ["bike"],
  "Intruder Motion": ["intruder_motion"],
  "Vehicle Motion": ["vehicle_motion"],
  "Bike Motion": ["bike_motion"],
  Crowd: ["crowd"],
  Fire: ["fire"],
  Smoke: ["smoke"],
  Amazon: ["amazon"],
  DHL: ["dhl"],
  Fedex: ["fedex"],
  "School Bus": ["school_bus"],
  UPS: ["ups"],
  USPS: ["usps"],
  "Fire Truck": ["fire_truck"],
  "Non-UPS": ["non_ups"],
  Envera: ["envera"],
  Gun: ["gun"],
  Pistol: ["pistol"],
  Loiterer: ["loiterer"],
  "Vehicle Loiterer": ["vehicle_loiterer"],
  "No Hard Hat": ["no_hard_hat"],
  "Intruder Line Crossing": ["intruder_line_crossing"],
  "Vehicle Line Crossing": ["vehicle_line_crossing"],
};

export const ACTIVE_PRODUCTS_DISPLAY_NAMES = [
  "Intruder",
  "Vehicle",
  "Bike",
  "Intruder Motion",
  "Vehicle Motion",
  "Bike Motion",
  "Crowd",
  "Gun",
  "Pistol",
  "Loiterer",
  "Vehicle Loiterer",
  "No Hard Hat",
  "Fire",
  "Smoke",
  "Intruder Line Crossing",
  "Vehicle Line Crossing",
  "Amazon",
  "DHL",
  "Fedex",
  "School Bus",
  "UPS",
  "USPS",
  "Envera",
  "Fire Truck",
  "Non-UPS",
] as const;

export type ActiveProductsResult = Record<string, boolean>;

interface StreamMetric {
  label_name: string;
  active: boolean;
}

interface StreamWithMetrics {
  stream_metrics?: StreamMetric[];
}

/**
 * Builds a map of label_name -> metric, preferring the metric with active: true when
 * the same label appears in multiple streams (mirrors generateActiveProducts logic).
 */
export function deriveActiveProductsFromGeneralInfo(
  streams: StreamWithMetrics[] | null | undefined
): ActiveProductsResult {
  const productsMap = new Map<string, boolean>();

  if (streams && Array.isArray(streams)) {
    streams.forEach((stream) => {
      (stream.stream_metrics || []).forEach((metric: StreamMetric) => {
        if (!productsMap.has(metric.label_name) || metric.active) {
          productsMap.set(metric.label_name, metric.active);
        }
      });
    });
  }

  const result: ActiveProductsResult = {};
  ACTIVE_PRODUCTS_DISPLAY_NAMES.forEach((displayName) => {
    const candidateLabelNames = DISPLAY_NAME_TO_LABEL_NAMES[displayName] || [];
    result[displayName] = candidateLabelNames.some(
      (labelName) => productsMap.get(labelName) === true
    );
  });
  return result;
}
